"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var enums_1 = require("@ikea-aoa/enums");
var ITEM_NO_NUMBER_OF_CHARACTERS = 3;
var ENERGY_CLASS_REGEXP = /^(A\+{0,3}|B|C|D|E)/;
/**
 * A product utility that can be used for formatting article numbers.
 */
var ProductUtility = /** @class */ (function () {
    function ProductUtility() {
    }
    /**
     * Formats a product article number to be more readable for the end user. The string "12535352" will for example be formatted to "125.353.52".
     *
     * @param itemNo Product item number.
     * @returns An item number including dots.
     */
    ProductUtility.formatItemNo = function (itemNo) {
        var numberOfDots = Math.ceil(itemNo.length / ITEM_NO_NUMBER_OF_CHARACTERS);
        var parts = Array(numberOfDots)
            .fill(null)
            .map(function (_, index) {
            return itemNo.slice(index * ITEM_NO_NUMBER_OF_CHARACTERS, index * ITEM_NO_NUMBER_OF_CHARACTERS + ITEM_NO_NUMBER_OF_CHARACTERS);
        });
        return parts.join('.');
    };
    /**
     * Returns product information page link.
     *
     * @param product Product.
     * @param localizedInformation Localized information object.
     * @param localizedInformation.urls
     * @param localizedInformation.urls.productInformationPageLink
     * @returns Product information page link.
     */
    ProductUtility.getProductInformationPageLink = function (product, localizedInformation) {
        if (!product.content || !localizedInformation.urls.productInformationPageLink) {
            return null;
        }
        var prefix = product.content.itemType === 'SPR' ? 'S' : '';
        var itemNo = product.content.itemNoLocal || product.content.itemNoGlobal;
        return localizedInformation.urls.productInformationPageLink.replace('{productItemNo}', "" + prefix + itemNo);
    };
    /**
     * Returns main image.
     *
     * @param product Product.
     * @returns Product images.
     */
    ProductUtility.getMainImages = function (product) {
        return product.content && product.content.image
            ? product.content.image.filter(function (image) { return image.typeName === enums_1.ImageTypeNameEnum.mainProductPicture; })
            : [];
    };
    /**
     * Returns energy class.
     *
     * @param product Product.
     * @returns Energy class.
     */
    ProductUtility.getEnergyClass = function (product) {
        var _a, _b;
        if (!((_b = (_a = product.content) === null || _a === void 0 ? void 0 : _a.technicalInformation) === null || _b === void 0 ? void 0 : _b.length)) {
            return null;
        }
        for (var _i = 0, _c = product.content.technicalInformation; _i < _c.length; _i++) {
            var item = _c[_i];
            if (typeof item.valueMetric === 'string') {
                var match = item.valueMetric.match(ENERGY_CLASS_REGEXP);
                if (match) {
                    return match[1];
                }
            }
        }
        return null;
    };
    return ProductUtility;
}());
exports.default = ProductUtility;
//# sourceMappingURL=ProductUtility.js.map